/**
 * Check if user is authenticated before making API calls
 * If not authenticated, redirect to login page
 * @param {object} navigate - React Router navigate function
 * @param {string} returnPath - Path to return to after login
 * @returns {boolean} - True if authenticated, false otherwise
 */
export const checkAuthBeforeAction = (navigate, returnPath = null) => {
  const token = localStorage.getItem('token');

  if (!token) {
    // Redirect to login page with return path
    navigate('/login', {
      replace: false,
      state: { from: returnPath || window.location.pathname }
    });
    return false;
  }

  return true;
};

/**
 * Check if user is authenticated
 * @returns {boolean} - True if authenticated, false otherwise
 */
export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};
